export type VoorraadSeverityVariant = 'success' | 'warning' | 'error';

/**
 * Classifies voorraad into a severity variant using business checks:
 * - success (green): enough including claims (overOfTekort >= 0)
 * - warning (orange): shortage exists, but can be solved by sacrificing overige claims
 *   (overOfTekort + claimsCount >= 0)
 * - error (red): even after sacrificing claims, shortage remains
 *
 * Anything derived from `variant` (dot counts, displayed numbers, row counts, ...) is
 * purely presentational and should be mapped locally at the call site, e.g. via a
 * `Record<VoorraadSeverityVariant, X>` lookup.
 */
export const getVoorraadSeverity = (aantal: number, claimsCount: number = 0): VoorraadSeverityVariant => {
  if (aantal >= 0) return 'success';
  if (aantal + claimsCount >= 0) return 'warning';
  return 'error';
};
